var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import cxs from 'cxs';
import Theme from 'Theme';
import { t } from 'helpers/i18n';
import { Select } from 'elements';
class FieldSelect extends Component {
    constructor() {
        super(...arguments);
        this.handleChange = (event) => {
            this.props.onChange(this.props.name, event.target.value || null, this.props.column);
        };
    }
    render() {
        const _a = this.props, { name, required, onChange } = _a, props = __rest(_a, ["name", "required", "onChange"]);
        return (React.createElement(Select, Object.assign({}, props, { label: t(name) + (required ? '*' : ''), className: className, onChange: this.handleChange })));
    }
}
export default FieldSelect;
const className = cxs({
    margin: Theme.size.space[1]
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/FieldSelect.tsx
// module id = 379
// module chunks = 0